import React from "react";

const Intro = () => {
  return (
    <section className="section-container">
      <div className="top-content">
        <h1>My Work</h1>
        <p className="description">
          This page showcases the different projects I have worked on over the
          years. While I cannot provide links to everything due to security
          concerns I do explain in detail the project goal and my role in it.
        </p>
      </div>
    </section>
  );
};

export default Intro;
